export const setNotificationAlert = (value) => ({
    type: 'NOTIFICATION_ALERT_TEXT',
    value
});